<template>
  <div class="row">
    <div class="col-md-12">
      <vs-button icon="refresh" color="dark" @click="refreshDataHandler" class="mb-2">
        Actualizar
      </vs-button>
      <vs-table :data="investorInterestTrx" stripe>
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Tipo trx</vs-th>
          <vs-th>Referencia</vs-th>
          <vs-th>Referencia Interés Inversionista</vs-th>
          <vs-th>Referencia Retención Inversionista</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>Concepto</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(item, i) in data" :key="i">
            <vs-td>
              <span @click="interestTrxSelectedHandler(item)" class="underline cursor-pointer">
              {{ item.id }}
              </span>
            </vs-td>
            <vs-td>{{ item.trx_type }}</vs-td>
            <vs-td>{{ item.reference }}</vs-td>
            <vs-td :class="{'text-danger': item.investor_interest_reference !== item.investor_retention_reference}">
              {{ item.investor_interest_reference }}
            </vs-td>
            <vs-td :class="{'text-danger': item.investor_interest_reference !== item.investor_retention_reference}">
              {{ item.investor_retention_reference }}
            </vs-td>
            <vs-td>{{ item.amount }}</vs-td>
            <vs-td>{{ item.concept }}</vs-td>
            <vs-td>
              <vs-button
                @click="updateReferenceHandler(item)"
                v-if="item.investor_interest_reference !== item.investor_retention_reference"
              >
                Actualizar referencias
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="col-md-6"></div>
  </div>
</template>
<script>
export default {
  name: "InvestorRetentionTrxUpdater",
  props: {
    interestTrxIds: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({
    investorInterestTrx: [],
    investorInterestTrxSelected: null,
  }),
  async mounted() {
    await this.getInvestorInterestTrx();
  },
  methods: {
    async refreshDataHandler() {
      await this.getInvestorInterestTrx();
    },
    async getInvestorInterestTrx() {
      this.$vs.loading();

      try {
        const {data} = await axios.post('/api/billing/trx/retention/investor', {
          interestTrxIds: this.interestTrxIds
        });
        this.investorInterestTrx = data;
      } catch (error) {
        this.$vs.loading.close();
        this.errorNotif("Error", "Error al obtener las transacciones de interés inversionista");
      } finally {
        this.$vs.loading.close();
      }
    },
    async updateReferenceHandler(item) {
      this.$vs.loading();
      try {
        await axios.put('/api/billing/trx/retention/investor', {
          interestTrxId: item.id,
          investorInterestReference: item.investor_interest_reference,
          investorRetentionReference: item.investor_retention_reference,
        })
      } catch (e) {
        this.$vs.loading.close();
        this.errorNotif("Error", "Error al actualizar las referencias");
      } finally {
        this.$vs.loading.close();
        await this.getInvestorInterestTrx();
      }
    }
  }
}
</script>

<style scoped>

</style>